import React from "react";
import '../styles/publicationcard.css'
const PublicationCard = ({ publications }) => {
  return (
    <>
      {publications.map((prop) => (
        <div key={prop.id} className="publicationcard">
          <a href={`https://doi.org/${prop.DOI}`} target="_blank" rel="noopener noreferrer" className="publicationname">
            {prop.publicationName}
            </a>
          <hr />
          <div className="publisher"><span className="publisher-span"> Publisher</span>: {prop.publisher}</div>
          <div className="conf-name"><span className="publisher-span"> Conference</span>: {prop.conferenceName}</div>
          <div className="date"> 
          <span className="publisher-span">Date of Publishing:        </span>
          {new Date(prop.publicationDate).toLocaleDateString("en-GB")}
          <br />
        </div>

        </div>
      ))}
    </>
  );
};

export default PublicationCard;
